<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_parents'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="row">
                <b-form-group class="col-md-3 px-1" label="Class">
                  <v-select
                    :options="schoolclasses"
                    placeholder="Select Class"
                    v-model="schoolclass"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2 px-1" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                  ></v-select>
                </b-form-group>
                <div class="col-md-2 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Filter</b-button
                  >
                </div>

                <div class="d-flex justify-content-end">
                  <div class="ms-2">
                    <b-button
                      size="lg"
                      variant="outline-danger"
                      @click="printParents()"
                    >
                      <i class="mdi mdi-file-pdf-box"></i> Download PDF
                    </b-button>
                  </div>
                  <div class="ms-2">
                    <b-button size="lg" variant="primary" v-b-modal.add-parent
                      ><i class="mdi mdi-plus"></i> Add Parent</b-button
                    >
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(name)="data">
                    <b class="upper-case">{{ data.item.parent.name }}</b>
                  </template>
                  <template #cell(gender)="data">
                    {{ data.item.parent.gender }}
                  </template>
                  <template #cell(telephone)="data">
                    {{ data.item.parent.telephone }}
                  </template>
                  <template #cell(address)="data">
                    {{ data.item.parent.address }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="view(data.item)"
                        type="button"
                        class="btn-sm btn"
                        variant="secondary"
                        v-b-modal.view-students
                        title="View Children"
                      >
                        <i class="mdi mdi-eye"></i>
                      </b-button>
                      <b-button
                        @click="assign(data.item.parent.id)"
                        type="button"
                        class="btn-sm btn"
                        variant="success"
                        v-b-modal.assign-students
                        title="Assign Student"
                      >
                        <i class="mdi mdi-account-multiple-plus"></i>
                      </b-button>
                      <b-button
                        @click="
                          edit(
                            data.item.parent.id,
                            data.item.parent.name,
                            data.item.parent.gender,
                            data.item.parent.telephone,
                            data.item.parent.address,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="info"
                        v-b-modal.edit-parent
                        title="Edit Parent"
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="
                          remove(data.item.parent.id, data.item.parent.name)
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.delete-parent
                        title="Delete Parent"
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- View Students Modal -->
      <b-modal
        id="view-students"
        centered
        title="View Children"
        title-class="font-14"
        hide-footer
      >
        <table
          class="table table-sm mt-2"
          style="color: black;"
          density="compact"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Student Details</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in childrenList" :key="item.student_id">
              <td>{{ item.last_name }} {{ item.first_name }}</td>
              <td>
                {{ item.class_name }} {{ item.stream_name }} -<small
                  style="color:red;"
                  >{{ item.student_id }}</small
                >
              </td>
              <td>
                <b-button
                  @click="unassign(item.student_id, currentParentId)"
                  type="button"
                  class="btn-sm btn"
                  variant="danger"
                  v-b-modal.unassign-parent
                  title="Unassign Student"
                >
                  <i class="mdi mdi-trash-can"></i> Unassign
                </b-button>
              </td>
            </tr>
            <tr v-if="childrenList.length === 0">
              <td colspan="3" class="text-center">No students assigned</td>
            </tr>
          </tbody>
        </table>
      </b-modal>

      <!-- Assign Students Modal -->
      <b-modal
        id="assign-students"
        centered
        title="Assign Another Student to Parent / Guardian"
        title-class="font-14"
        hide-footer
        @hidden="resetAssignForm"
      >
        <form @submit.prevent="assignStudent">
          <div class="form-group mb-2">
            <label>Student :</label>
            <multiselect
              v-model="parentStudentId"
              :options="students"
              placeholder="Select Student"
              :custom-label="customLabel"
            ></multiselect>
            <!-- <select class="form-control" v-model="selectedStudentId" required>
              <option value="">-- Select Student --</option>
              <option
                v-for="student in studentsList"
                :key="student.student_id"
                :value="student.student_id"
              >
                {{ student.display_name }}
              </option>
            </select> -->
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('assign-students')"
            >
              Close
            </b-button>
            <b-button
              type="submit"
              class="btn ms-1 w-30"
              variant="primary"
              :disabled="!selectedStudentId"
            >
              <i class="fas fa-check-circle"></i> Submit
            </b-button>
          </div>
        </form>
      </b-modal>

      <!-- Add Parent Modal -->
      <b-modal
        id="add-parent"
        centered
        title="Add Parent / Guardian"
        title-class="font-14"
        hide-footer
        @hidden="resetAddForm"
      >
        <form @submit.prevent="addParent">
          <div class="form-group mb-2">
            <label>Name</label>
            <input
              v-model="parentName"
              type="text"
              class="form-control"
              required
            />

            <label class="mt-2">Gender</label>
            <select class="form-control" v-model="parentGender" required>
              <option value="">Select Gender</option>
              <option>Female</option>
              <option>Male</option>
            </select>

            <label class="mt-2">Telephone</label>
            <input
              v-model="parentTelephone"
              type="number"
              class="form-control"
              required
            />

            <label class="mt-2">Email Address</label>
            <input v-model="parentEmail" type="email" class="form-control" />

            <label class="mt-2"
              >Student : <small class="text-primary"></small
            ></label>
            <multiselect
              v-model="parentStudentId"
              :options="students"
              placeholder="Select Student"
              :custom-label="customLabel"
            ></multiselect>
            <!-- <select class="form-control" v-model="parentStudentId">
              <option value="">-- Select Student --</option>
              <option
                v-for="student in studentsList"
                :key="student.student_id"
                :value="student.student_id"
              >
                {{ student.display_name }}
              </option>
            </select> -->
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('add-parent')"
            >
              Close
            </b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary">
              <i class="fas fa-check-circle"></i> Submit
            </b-button>
          </div>
        </form>
      </b-modal>

      <!-- Edit Parent Modal -->
      <b-modal
        id="edit-parent"
        centered
        title="Edit Parent / Guardian"
        title-class="font-14"
        hide-footer
        @hidden="resetEditForm"
      >
        <form @submit.prevent="editParent">
          <div class="form-group mb-2">
            <label>Name</label>
            <input
              v-model="parentName"
              type="text"
              class="form-control"
              required
            />

            <label class="mt-2">Gender</label>
            <select class="form-control" v-model="parentGender" required>
              <option>Female</option>
              <option>Male</option>
            </select>

            <label class="mt-2">Telephone</label>
            <input
              v-model="parentTelephone"
              type="number"
              class="form-control"
              required
            />

            <label class="mt-2">Email Address</label>
            <input v-model="parentEmail" type="email" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-parent')"
            >
              Close
            </b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary">
              <i class="fas fa-check-circle"></i> Submit
            </b-button>
          </div>
        </form>
      </b-modal>

      <!-- Delete Parent Modal -->
      <b-modal
        id="delete-parent"
        centered
        title="Delete Parent / Guardian"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeParent">
          <input v-model="parentId" type="hidden" />
          Are you sure you want to delete the Parent / Guardian :
          <b>{{ parentName }}</b> ?
          <div class="form-group d-flex justify-content-end mt-3">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-parent')"
            >
              Close
            </b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="danger">
              <i class="fas fa-trash"></i> Delete
            </b-button>
          </div>
        </form>
      </b-modal>

      <!-- Unassign Parent Modal -->
      <b-modal
        id="unassign-parent"
        centered
        title="Unassign Student from Parent / Guardian"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="unassignParent">
          <input v-model="unassignParentId" type="hidden" />
          <input v-model="unassignStudentId" type="hidden" />
          Are you sure you want to unassign this Student from the Parent /
          Guardian ?
          <div class="form-group d-flex justify-content-end mt-3">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('unassign-parent')"
            >
              Close
            </b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="danger">
              <i class="fas fa-trash"></i> Unassign
            </b-button>
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import {
  parentComputed,
  parentMethods,
  schoolclassComputed,
  schoolclassMethods,
  studentMethods,
  studentComputed,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Parents",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Parents / Guardians",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Parents / Guardians", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Name", visible: true },
        { key: "gender", label: "Gender", visible: true },
        { key: "telephone", label: "Telephone", visible: true },
        { key: "address", label: "Email Address", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      year: new Date().getFullYear(),
      //schoolclasses: [],

      // Parent form data
      parentId: "",
      parentName: "",
      parentGender: "",
      parentTelephone: "",
      parentEmail: "",
      parentStudentId: "",

      // Assign/Unassign data
      selectedStudentId: "",
      currentParentId: "",
      unassignStudentId: "",
      unassignParentId: "",

      // Lists
      childrenList: [],

      // Filters
      schoolclass: "",
    };
  },
  computed: {
    ...parentComputed,
    ...studentComputed,
    ...schoolclassComputed,
    List() {
      return this.parents.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.parents.map((d) => ({ ...d }));
    },
    IsBusy() {
      return this.parents.length === 0;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
    studentsList() {
      if (this.students && this.students.length) {
        return this.students.map((student) => ({
          student_id: student.student?.student_id || student.id,
          display_name: `${student.student?.first_name || ""} ${student.student
            ?.last_name || ""} - ${student.class?.name || ""} ${student.stream
            ?.name || ""}`.trim(),
          raw_data: student,
        }));
      }
      return [];
    },
  },
  mounted() {
    this.fetchParents();
    this.fetchStudents();
    this.fetchSchoolClasses();
    this.TotalRows = this.parents.length;
  },
  methods: {
    ...parentMethods,
    ...studentMethods,
    ...schoolclassMethods,

    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name}`;
    },

    printParents() {
      const query = {
        year: this.year,
      };
      // Pass class info only when a class is selected
      if (this.schoolclass && this.schoolclass.id) {
        query.class = this.schoolclass.id;
        query.class_name = this.schoolclass.name;
      }

      const routeData = this.$router.resolve({
        path: "/printparents",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    FilterData() {
      this.filterParents({ schoolclass: this.schoolclass.id, year: this.year });
    },

    view(data) {
      this.childrenList = (data.children || []).map((child) => ({
        student_id: child.student_id,
        first_name: child.first_name,
        last_name: child.last_name,
        class_name: child.class_name,
        stream_name: child.stream_name,
      }));
      this.currentParentId = data.parent.id;
      this.$bvModal.show("view-students");
    },

    assign(id) {
      this.currentParentId = id;
      this.selectedStudentId = "";
      this.$bvModal.show("assign-students");
    },

    edit(id, name, gender, telephone, address) {
      this.parentId = id;
      this.parentName = name;
      this.parentGender = gender;
      this.parentTelephone = telephone;
      this.parentEmail = address;
      this.$bvModal.show("edit-parent");
    },

    remove(id, name) {
      this.parentId = id;
      this.parentName = name;
      this.$bvModal.show("delete-parent");
    },

    unassign(student_id, parent_id) {
      this.unassignStudentId = student_id;
      this.unassignParentId = parent_id;
      this.$bvModal.show("unassign-parent");
    },

    resetAssignForm() {
      this.selectedStudentId = "";
      this.currentParentId = "";
    },

    resetAddForm() {
      this.parentName = "";
      this.parentGender = "";
      this.parentTelephone = "";
      this.parentEmail = "";
      this.parentStudentId = "";
    },

    resetEditForm() {
      this.parentId = "";
      this.parentName = "";
      this.parentGender = "";
      this.parentTelephone = "";
      this.parentEmail = "";
    },

    async addParent() {
      let formData = new FormData();
      formData.append("name", this.parentName);
      formData.append("gender", this.parentGender);
      formData.append("telephone", this.parentTelephone);
      formData.append("address", this.parentEmail);
      formData.append("student", this.parentStudentId.student.student_id);

      let url = "/addparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if (response.data.error) {
            this.$swal({
              title: "Error",
              text: response.data.error,
              icon: "error",
            });
          } else {
            this.fetchParents();
            this.$bvModal.hide("add-parent");
            this.resetAddForm();
            this.$swal({
              title: "Success",
              text: response.data.message,
              icon: "success",
            });
          }
        }
      });
    },

    async editParent() {
      let formData = new FormData();
      formData.append("id", this.parentId);
      formData.append("name", this.parentName);
      formData.append("gender", this.parentGender);
      formData.append("telephone", this.parentTelephone);
      formData.append("address", this.parentEmail);

      let url = "/updateparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchParents();
          this.$bvModal.hide("edit-parent");
          this.resetEditForm();
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },

    async removeParent() {
      let formData = new FormData();
      formData.append("id", this.parentId);
      let url = "/removeparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchParents();
          this.$bvModal.hide("delete-parent");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },

    async assignStudent() {
      if (!this.selectedStudentId) {
        this.$swal({
          title: "Error",
          text: "Please select a student",
          icon: "error",
        });
        return;
      }

      let formData = new FormData();
      formData.append("parent_id", this.currentParentId);
      formData.append("student_id", this.selectedStudentId.student.student_id);

      let url = "/assignstudenttoparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchParents();
          this.$bvModal.hide("assign-students");
          this.resetAssignForm();
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },

    async unassignParent() {
      let formData = new FormData();
      formData.append("parent_id", this.unassignParentId);
      formData.append("student_id", this.unassignStudentId);

      let url = "/unassignstudentfromparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchParents();
          this.$bvModal.hide("unassign-parent");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.btn-group {
  display: flex;
  gap: 5px;
}
.w-30 {
  width: 30%;
}

/* Tooltip styling for buttons */
.btn-group .btn {
  position: relative;
}

.btn-group .btn:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 5px;
  pointer-events: none;
}

.btn-group .btn:hover::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
  margin-bottom: -5px;
  z-index: 1000;
  pointer-events: none;
}
</style>
